export const M8_UNIT_1 = {
  id: "m8-u1-travel-transportation",
  title: "Unit 1: Travel & Transportation",
  grammarText: "Collocations (pack luggage/board plane/check in) + Present Perfect (I've just arrived/I've been traveling) + PP Continuous questions (How long have you been waiting?).",
  grammarImage: "/grammar/m8-u1.jpg",
  sets: [

    // SET 1: Airport Arrival (basic collocations)
    {
      id: "m8-u1-s1",
      title: "Set 1: Airport Arrival",
      context: `*EducaT Mexico International Airport*\n\nYou're arriving for your adventure trip. Check luggage, find taxi rank. Practice basic travel collocations.\n\n*Mexico City Airport*\n\nLuggage carousel spinning. Taxi queue forming.`,
      questions: [
        {type: "match", q: "Travel collocations:", pairs: [{left: "pack", right: "your bags"}, {left: "arrive at", right: "the airport"}, {left: "wait at", right: "taxi rank"}, {left: "get on", right: "a bus"}], a: "completed", successTip: "PACK YOUR BAGS! Always 'pack luggage' (not make). US: suitcase / UK: luggage."},
        {type: "order", q: "Traduce: 'Empaca tus maletas'", words: ["Pack", "your", "bags."], a: "Pack your bags.", extra: ["Make", "suitcase"], tip: "Pack + bags/luggage (collocation fija)."},
        {type: "mc", q: "At the airport: Wait at the ___", options: ["taxi rank", "bus station", "hotel lobby"], a: "taxi rank", tip: "Taxi rank = parada taxis (UK). US: taxi stand."},
        {type: "mc", q: "You ___ at the airport.", options: ["arrive", "depart"], a: "arrive"},
        {type: "input", q: "___ your bags before flying.", a: "Pack"},
        {type: "match", q: "Places:", pairs: [{left: "Airport", right: "runway"}, {left: "Train", right: "station"}, {left: "Bus", right: "stop"}, {left: "Taxi", right: "rank"}], a: "completed"},
        {type: "order", q: "Traduce: 'Llega al aeropuerto'", words: ["Arrive", "at", "the", "airport."], a: "Arrive at the airport.", extra: ["Go to", "reach"], tip: "Arrive at + lugar específico."},
        {type: "mc", q: "UK: Taxi ___ / US: Taxi ___", options: ["rank/stand", "stop/station"], a: "rank/stand"},
        {type: "input", q: "Get ___ a taxi.", a: "in"},
        {type: "mc", q: "Pack your bags and ___ at the airport.", options: ["arrive", "fly", "go"], a: "arrive", successTip: "AIRPORT READY! 'Arrive at' + airport/station. Chain: pack → arrive → taxi. ✈️"}
      ]
    },

    // SET 2: Check-in & Boarding
    {
      id: "m8-u1-s2",
      title: "Set 2: Check-in & Boarding",
      context: `*Airport Check-in Counter*\n\nLong queue. Show passport, drop luggage. Board your flight soon.\n\n*Check-in desk*\n\nAgent: 'Passport please. Have you packed your own bags?'`,
      questions: [
        {type: "match", q: "Airport actions:", pairs: [{left: "check-in", right: "at desk"}, {left: "board", right: "a plane"}, {left: "go through", right: "security"}, {left: "wait at", right: "gate"}], a: "completed"},
        {type: "order", q: "Traduce: 'Regístrate en el mostrador'", words: ["Check", "in", "at", "the", "desk."], a: "Check in at the desk.", extra: ["Register", "sign"], tip: "Check-in = registro (collocation obligatoria)."},
        {type: "mc", q: "Before flying: ___ a plane.", options: ["board", "get off"], a: "board"},
        {type: "mc", q: "'Have you ___ your own bags?'", options: ["packed", "made"], a: "packed"},
        {type: "input", q: "___ through security.", a: "Go"},
        {type: "match", q: "Sequence:", pairs: [{left: "1. Arrive", right: "airport"}, {left: "2. Check-in", right: "desk"}, {left: "3. Security", right: "scanner"}, {left: "4. Board", right: "plane"}], a: "completed", successTip: "BOARDING FLOW! US: 'boarding pass' / UK: same. Never 'enter plane'!"},
        {type: "order", q: "Traduce: 'Pasa por seguridad'", words: ["Go", "through", "security."], a: "Go through security.", extra: ["Pass", "check"], tip: "Go through = pasar por (aeropuerto)."},
        {type: "mc", q: "Wait at the ___", options: ["gate", "counter"], a: "gate"},
        {type: "input", q: "Show your boarding ___", a: "pass"},
        {type: "input", q: "Check in, go through security, ___ the plane.", a: "board", successTip: "CHECK-IN MASTER! 'Board a flight/plane'. Practice: 'Flight boarding now!' 🛫"}
      ]
    },

    // SET 3: Transport Types
    {
      id: "m8-u1-s3",
      title: "Set 3: Transport Types",
      context: `*Mexico City Transport Hub*\n\nChoose: taxi/bus/train/plane? Long-distance coach to beach?\n\n*Transport options*\n\nSigns: Trains/Buses/Taxis everywhere.`,
      questions: [
        {type: "match", q: "Get on/off:", pairs: [{left: "bus/train", right: "get on/off"}, {left: "plane", right: "board"}, {left: "car/taxi", right: "get in/out"}, {left: "bike", right: "ride"}], a: "completed"},
        {type: "order", q: "Traduce: 'Sube al autobús'", words: ["Get", "on", "the", "bus."], a: "Get on the bus.", extra: ["Enter", "climb"], tip: "Get on bus/train (UK/US). Plane=board."},
        {type: "mc", q: "Long distance: ___ coach.", options: ["take", "drive"], a: "take"},
        {type: "mc", q: "Airport: ___ a plane.", options: ["board", "get on"], a: "board"},
        {type: "input", q: "Ride a ___", a: "bike"},
        {type: "match", q: "Vehicles:", pairs: [{left: "Taxi", right: "rank"}, {left: "Bus", right: "stop"}, {left: "Train", right: "station"}, {left: "Plane", right: "terminal"}], a: "completed"},
        {type: "order", q: "Traduce: 'Conduce un carro'", words: ["Drive", "a", "car."], a: "Drive a car.", extra: ["Go", "ride"], tip: "Drive car/taxi/motorbike."},
        {type: "mc", q: "UK long bus: ___ / US: bus", options: ["coach", "minivan"], a: "coach"},
        {type: "input", q: "Take a ___ ride.", a: "train"},
        {type: "mc", q: "Get ____ the bus or board a plane.", options: ["board", "out", "on"], a: "on", successTip: "TRANSPORT PRO! 'Take a train/bus/coach'. Never 'ride bus'. Global travel ready! 🚍✈️🚂"}
      ]
    },

    // SET 4: Hotel Check-in
    {
      id: "m8-u1-s4",
      title: "Set 4: Hotel Check-in",
      context: `*EducaT Adventure Hotel Beach Resort*\n\nArrive after flight. Reception desk, book room, luggage to room.\n\n*Hotel lobby*\n\nReceptionist: 'Welcome! Checking in?'`,
      questions: [
        {type: "match", q: "Hotel:", pairs: [{left: "arrive at", right: "hotel"}, {left: "check into", right: "hotel"}, {left: "stay in", right: "room"}, {left: "leave", right: "hotel"}], a: "completed"},
        {type: "order", q: "Traduce: 'Regístrate en el hotel'", words: ["Check", "into", "a", "hotel."], a: "Check into a hotel.", extra: ["Enter", "book"], tip: "Check into hotel/hostel (no 'check in hotel')."},
        {type: "mc", q: "Reception = ___", options: ["front desk", "kitchen"], a: "front desk"},
        {type: "mc", q: "Vacation = ___ (US/UK)", options: ["vacation/holiday", "trip/outing"], a: "vacation/holiday"},
        {type: "input", q: "___ your bags in the room.", a: "Take"},
        {type: "match", q: "Accommodation:", pairs: [{left: "Hotel", right: "reception"}, {left: "Hostel", right: "dorm"}, {left: "Check-in", right: "passport"}], a: "completed", successTip: "'CHECK INTO'! US: check-in / UK: same. 'Front desk' everywhere."},
        {type: "order", q: "Traduce: 'Quédate en el hotel'", words: ["Stay", "in", "a", "hotel."], a: "Stay in a hotel.", extra: ["Live", "sleep"], tip: "Stay in + hotel/hostel."},
        {type: "mc", q: "Leave the ___", options: ["hotel", "airport"], a: "hotel"},
        {type: "input", q: "Welcome to the ___!", a: "hotel"},
        {type: "order", q: "Full: Arrive at hotel, check ___, stay overnight.", words: ["into"], a: "Arrive at hotel, check into, stay overnight.", successTip: "HOTEL CHAIN! 'Check out' tomorrow. Adventure starts! 🏨🌴"}
      ]
    },

    // SET 5: Present Perfect Intro (recent travel)
    {
      id: "m8-u1-s5",
      title: "Set 5: Recent Travel (PP)",
      context: `*Post-flight debrief*\n\nTeacher: 'Where have you been? What have you just done?' Share travel experiences.\n\n*Airport lounge*\n\nFresh from flight: 'I've just arrived!'`,
      questions: [
        {type: "match", q: "PP forms:", pairs: [{left: "I/You/We/They", right: "have"}, {left: "He/She/It", right: "has"}, {left: "I've", right: "arrived"}, {left: "She's", right: "gone"}], a: "completed"},
        {type: "order", q: "Traduce: 'Acabo de llegar'", words: ["I've", "just", "arrived."], a: "I've just arrived.", extra: ["I arrive now", "I arrived"], tip: "Just = recién (entre have + participle)."},
        {type: "mc", q: "I've ___ Mexico.", options: ["been to", "gone to"], a: "been to", tip: "Been to = visitado y regresado."},
        {type: "mc", q: "She ___ to Paris (still there).", options: ["has gone", "has been"], a: "has gone"},
        {type: "input", q: "We ___ packed our bags.", a: "have"},
        {type: "match", q: "Recent:", pairs: [{left: "Just arrived", right: "at airport"}, {left: "Already checked-in", right: "hotel"}, {left: "Gone on", right: "vacation"}], a: "completed"},
        {type: "order", q: "Traduce: 'Ya he empacado'", words: ["I've", "already", "packed."], a: "I've already packed.", extra: ["I pack now"], tip: "Already = ya (before have verb)."},
        {type: "mc", q: "PP negative: I ___ arrive yet.", options: ["haven't", "hasn't"], a: "haven't"},
        {type: "input", q: "Has she ___ through security?", a: "gone"},
        {type: "order", q: "Full PP: I've just arrived and already ___ my bags.", words: ["packed"], a: "I've just arrived and already packed my bags.", successTip: "PP NEWS! 'Just/already' for recent. US/UK same. 'I've been to' = visited! 🌍"}
      ]
    },

    // SET 6: PP with Adverbs
    {
      id: "m8-u1-s6",
      title: "Set 6: PP Adverbs",
      context: `*Travel chat lounge*\n\n'I've just boarded / already checked-in / not yet arrived / still waiting.'\n\n*Lounge talk*\n\nFriends share: 'Still haven't seen kangaroo yet!'`,
      questions: [
        {type: "match", q: "Adverbs:", pairs: [{left: "just", right: "short time ago"}, {left: "already", right: "earlier than expected"}, {left: "yet", right: "negative/questions"}, {left: "still", right: "ongoing"}], a: "completed"},
        {type: "order", q: "Traduce: 'Todavía no he llegado'", words: ["I", "haven't", "arrived", "yet."], a: "I haven't arrived yet.", extra: ["I don't arrive"], tip: "Yet = aún (end negative)."},
        {type: "mc", q: "I've ___ my passport.", options: ["already found", "yet found"], a: "already found"},
        {type: "mc", q: "The plane ___ taken off.", options: ["hasn't yet", "has yet"], a: "hasn't yet"},
        {type: "input", q: "Still ___ at the gate.", a: "waiting"},
        {type: "match", q: "Position:", pairs: [{left: "Just/Already", right: "before main verb"}, {left: "Yet", right: "end negative"}, {left: "Still", right: "after subject"}], a: "completed", successTip: "ADVERB PRO! 'Still waiting? / Already boarded?' Natural chat."},
        {type: "order", q: "Traduce: 'Todavía estoy esperando'", words: ["I'm", "still", "waiting."], a: "I'm still waiting.", extra: ["I wait still"], tip: "Still = todavía (after subject)."},
        {type: "mc", q: "Flight ___ delayed.", options: ["is still", "still is"], a: "is still"},
        {type: "input", q: "Have you ___ boarded?", a: "already"},
        {type: "order", q: "Scenario: I've already checked-in but still ___ security.", words: ["waiting for"], a: "I've already checked-in but still waiting for security.", successTip: "ADVERB MIX! 'Not yet / already done / still going / just finished'. Travel fluency! ⏳"}
      ]
    },

    // SET 7: PP Continuous Intro
    {
      id: "m8-u1-s7",
      title: "Set 7: PP Continuous",
      context: `*Long journey debrief*\n\n'I've been traveling for 5 hours / since 6am. I'm exhausted!' Duration.\n\n*Journey end*\n\nCovered in sweat: 'Been waiting hours!'`,
      questions: [
        {type: "match", q: "PPC:", pairs: [{left: "have/has been", right: "+ing"}, {left: "for", right: "duration"}, {left: "since", right: "start point"}], a: "completed"},
        {type: "order", q: "Traduce: 'He estado viajando por horas'", words: ["I've", "been", "traveling", "for", "hours."], a: "I've been traveling for hours.", extra: ["I travel"], tip: "Been + ing = ongoing recent."},
        {type: "mc", q: "I've been ___ at airport.", options: ["waiting", "wait"], a: "waiting"},
        {type: "mc", q: "For/since: ___ 3 hours / ___ Monday.", options: ["for/since", "since/for"], a: "for/since"},
        {type: "input", q: "She's been packing ___ 2 hours.", a: "for"},
        {type: "match", q: "Duration:", pairs: [{left: "for 2 days", right: "duration"}, {left: "since noon", right: "start"}, {left: "all week", right: "ongoing"}], a: "completed"},
        {type: "order", q: "Traduce: 'Desde las 6am'", words: ["since", "6am."], a: "since 6am.", extra: ["for morning"], tip: "Since + punto inicio (hora/día)."},
        {type: "mc", q: "He's been driving ___ yesterday.", options: ["since", "for"], a: "since"},
        {type: "input", q: "We've been on plane ___ takeoff.", a: "since"},
        {type: "order", q: "Full: I've been waiting ___ 2 hours ___ 10am.", words: ["for", "since"], a: "I've been waiting for 2 hours since 10am.", successTip: "PPC DURATION! 'For hours / since dawn'. Explains why tired! 😴🚀"}
      ]
    },

    // SET 8: PPC Questions
    {
      id: "m8-u1-s8",
      title: "Set 8: PPC Questions",
      context: `*Customs queue*\n\nOfficer: 'How long have you been traveling? Have you been waiting long?' Evidence questions.\n\n*Customs chat*\n\nDirty clothes: 'Been hiking?'`,
      questions: [
        {type: "match", q: "Questions:", pairs: [{left: "Have you been", right: "waiting?"}, {left: "How long has he", right: "been driving?"}, {left: "Since when", right: "have you been here?"}], a: "completed"},
        {type: "order", q: "Traduce: '¿Cuánto tiempo has estado esperando?'", words: ["How", "long", "have", "you", "been", "waiting?"], a: "How long have you been waiting?", extra: ["How much time wait"], tip: "How long + have/has + S + been + ing."},
        {type: "mc", q: "___ you been flying?", options: ["Have", "Has"], a: "Have"},
        {type: "mc", q: "Evidence: Covered in mud? Have you been ___?", options: ["hiking", "sleeping"], a: "hiking"},
        {type: "input", q: "How long ___ she been at the hotel?", a: "has"},
        {type: "match", q: "Evidence Qs:", pairs: [{left: "Wet?", right: "raining?"}, {left: "Tired?", right: "traveling long?"}, {left: "Hungry?", right: "waiting?"}], a: "completed", successTip: "EVIDENCE MASTER! See dirt→'Been gardening?' Natural B2 talk."},
        {type: "order", q: "Traduce: '¿Has estado haciendo turismo?'", words: ["Have", "you", "been", "sightseeing?"], a: "Have you been sightseeing?", extra: ["Do you sightsee"], tip: "PPC para ongoing."},
        {type: "mc", q: "'How long ___ traveling?'", options: ["have you been", "are you"], a: "have you been"},
        {type: "input", q: "___ he been driving since morning?", a: "Has"},
        {type: "order", q: "Customs: How long have you ___ traveling? -___ 3 days.", words: ["been", "For"], a: "How long have you been traveling? -For 3 days.", successTip: "QUESTION CHAIN! 'How long? → For/since → Why tired?' B2 fluency unlocked! ❓"}
      ]
    },

    // SET 9: Integration (PP + Collocations)
    {
      id: "m8-u1-s9",
      title: "Set 9: Full Travel Chain",
      context: `*EducaT Adventure Debrief*\n\nFull story: 'I've just checked into hotel after boarding plane. Been traveling since dawn.'\n\n*Group share*\n\nEveryone exhausted but excited.`,
      questions: [
        {type: "match", q: "Mix:", pairs: [{left: "I've just boarded", right: "plane"}, {left: "Been waiting", right: "for bus"}, {left: "Already checked", right: "into hotel"}, {left: "Not yet", right: "unpacked"}], a: "completed"},
        {type: "order", q: "Traduce: 'Ya abordé el avión'", words: ["I've", "already", "boarded", "the", "plane."], a: "I've already boarded the plane.", extra: ["I board already"], tip: "PP + collocation."},
        {type: "mc", q: "I've been ___ for hours.", options: ["traveling", "sleep"], a: "traveling"},
        {type: "mc", q: "How long ___ you been at the airport?", options: ["have", "has"], a: "have"},
        {type: "input", q: "Checked ___ the hotel.", a: "into"},
        {type: "match", q: "Story:", pairs: [{left: "Pack bags", right: "home"}, {left: "Board plane", right: "airport"}, {left: "Check into", right: "hotel"}], a: "completed"},
        {type: "order", q: "Traduce: '¿Cuánto tiempo has estado en el tren?'", words: ["How", "long", "have", "you", "been", "on", "the", "train?"], a: "How long have you been on the train?", extra: ["How time train"], tip: "PPC + transport."},
        {type: "mc", q: "Still ___ unpacked.", options: ["haven't", "hasn't"], a: "haven't"},
        {type: "input", q: "Been cycling ___ hours.", a: "for"},
        {type: "order", q: "Boss chain: I've just arrived, checked into hotel, been ___ since morning.", words: ["traveling"], a: "I've just arrived, checked into hotel, been traveling since morning.", successTip: "CHAIN PRO! Collocations + PP seamless. 'Been on bus/plane/train'. Native story! 📖"}
      ]
    },

    // SET 10: B2 Mastery Review
    {
      id: "m8-u1-s10",
      title: "Set 10: Travel Mastery",
      context: `*EducaT Mexico Final Debrief*\n\nBoss: Tell full adventure: transports, timings, experiences. B2 fluency test.\n\n*Airport reunion*\n\n'Where've you been? How long traveling?'`,
      questions: [
        {type: "match", q: "Full mastery:", pairs: [{left: "Board plane", right: "PP: I've boarded"}, {left: "Check into hotel", right: "PPC: Been staying"}, {left: "Wait taxi", right: "Q: How long waiting?"}, {left: "Pack bags", right: "Adverb: Already packed"}], a: "completed"},
        {type: "order", q: "Traduce: 'He estado esperando el taxi por una hora'", words: ["I've", "been", "waiting", "for", "a", "taxi", "for", "an", "hour."], a: "I've been waiting for a taxi for an hour.", extra: ["I wait taxi"], tip: "Double for (duration + taxi)."},
        {type: "mc", q: "Best full: '___ plane, ___ hotel, ___ traveling hours.'", options: ["Boarded/checked into/been", "Get on/enter/been"], a: "Boarded/checked into/been"},
        {type: "mc", q: "US/UK: Vacation / ___", options: ["holiday", "outing"], a: "holiday"},
        {type: "input", q: "How long have you ___ packing?", a: "been"},
        {type: "mc", q: "She's still ___ the train.", options: ["on", "in"], a: "on"},
        {type: "order", q: "Traduce cierre: '¡Qué viaje increíble he tenido!'", words: ["What", "an", "amazing", "trip", "I've", "had!"], a: "What an amazing trip I've had!", extra: ["Great travel"], tip: "PP para experiencia completa."},
        {type: "input", q: "Get ___ the motorcycle.", a: "on"},
        {type: "mc", q: "Flight on time? No, still ___", options: ["delayed", "delay"], a: "delayed"},
        {type: "order", q: "Ultimate: How long have you been traveling? -___ dawn, just checked into hotel!", words: ["Since"], a: "How long have you been traveling? -Since dawn, just checked into hotel!", successTip: "M8-U1 CONQUERED! B2 travel boss: PP chains + collocations + questions. 'Safe travels!' Worldwide ready! 🌎✈️🏨🚀"}
      ]
    }
  ],

  // READINGSET con passages (2-3 preguntas/passage)
  readingSet: {
    id: "m8-u1-reading",
    title: "Reading: Mexico Adventure Journey",
    category: "reading",
    questions: [
      {
        type: "passage",
        passage: `**Airport Chaos in Mexico City**
Hi team! I've just arrived at Mexico City Airport. Chaos! Long queue at check-in desk. I packed my bags at home but still waiting for taxi rank. Finally boarded the plane after security.`
      },
      {
        type: "mc",
        q: "Where is speaker?",
        options: ["Mexico City Airport", "Hotel", "Train station"],
        a: "Mexico City Airport"
      },
      {
        type: "order",
        q: "Traduce: 'Acabo de llegar al aeropuerto'",
        words: ["I've", "just", "arrived", "at", "the", "airport."],
        a: "I've just arrived at the airport.",
        tip: "Just + PP para reciente."
      },
      {
        type: "passage",
        passage:`**Train to Beach Resort**
The train ride was amazing! Been traveling since 6am. Got on at station, now scenic views. How long have you been on trains? I've been cycling before but this is best.`
      },
      {
        type: "mc",
        q: "Travel since:",
        options: ["6am", "Noon", "Evening"],
        a: "6am"
      },
      {
        type: "input",
        q: "Got ___ at station.",
        a: "on"
      },
      {
        type: "passage",
        passage: `**Hotel Check-in Bliss**
Finally! Checked into beach hotel. Reception perfect. Stayed in hostels before but this luxury. Still haven't unpacked yet but already relaxing. What an adventure!`
      },
      {
        type: "order",
        q: "Traduce: 'Ya me registré en el hotel'",
        words: ["I've", "already", "checked", "into", "the", "hotel."],
        a: "I've already checked into the hotel.",
        successTip: "TRIP COMPLETE! PP + collocations perfect."
      },
      {
       type: "mc",
        q: "Still not:",
        options: ["unpacked", "checked-in", "arrived"],
        a: "unpacked"
      }
    ]
  },

  // REVIEWSET (sin passages, direct questions)
  reviewSet: {
    id: "m8-u1-review",
    title: "Unit 1 Mastery Review",
    category: "review",
    questions: [
      {
        type: "match",
        q: "Collocations full:",
        pairs: [
          {left: "pack/check-in/board", right: "bags/desk/plane"},
          {left: "get on/stay/drive", right: "bus/hotel/car"},
          {left: "arrive/wait", right: "airport/taxi rank"}
        ],
        a: "completed"
      },
      {
        type: "order",
        q: "Traduce clave: 'He estado en tren por horas'",
        words: ["I've", "been", "on", "the", "train", "for", "hours."],
        a: "I've been on the train for hours."
      },
      {
        type: "passage",
        q: "PP adverbs:",
        options: ["just/already/yet/still"],
        a: "just/already/yet/still",
        tip: "Posiciones clave."
      },
      {
        type: "mc",
        q: "Boss Q: ___ long have you been traveling?",
        options: ["How", "What"],
        a: "How"
      },
      {
        type: "input",
        q: "Check ___ hotel.",
        a: "into"
      },
      {
        type: "match",
        q: "Vocab mastery:",
        pairs: [
          {left: "taxi rank/bus stop", right: "UK/US: taxi stand"},
          {left: "coach/plane", right: "long distance/fly"},
          {left: "been to/gone to", right: "visited/still there"}
        ],
        a: "completed",
        successTip: "M8-U1 LOCKED! Travel B2: 'How long been waiting? Just checked in!' Global adventurer! 🌟"
      },
      {
        type: "order",
        q: "Final boss: I've just arrived, been traveling since dawn, checked ___ hotel.",
        words: ["into"],
        a: "I've just arrived, been traveling since dawn, checked into hotel."
      },
      {
        type: "mc",
        q: "On time?",
        options: ["Flight/train/bus all delayed still!"],
        a: "Flight/train/bus all delayed still!"
      },
      {
        type: "input",
        q: "Board a ___",
        a: "plane"
      },
      {
        type: "order",
        q: "Ultimate story: How long ___ you ___ sightseeing? -___ a week!",
        words: ["have", "been", "For"],
        a: "How long have you been sightseeing? -For a week!",
        successTip: "UNIT 1 B2 MASTERED! Collocations + PP/PPC fluent. Safe travels everywhere! ✈️🚀"
      }
    ]
  }
};
